export function AddIcon({ color }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16675 6.83342H0.166748V5.16675H5.16675V0.166748H6.83342V5.16675H11.8334V6.83342H6.83342V11.8334H5.16675V6.83342Z"
        fill={color || '#1A7FDC'}
      />
    </svg>
  );
}

export function MinusIcon({ color }) {
  return (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.166626 1.83341V0.166748H11.8333V1.83341H0.166626Z"
        fill={color || '#1A7FDC'}
      />
    </svg>
  );
}
